import CommentsoldIcon from "@redotech/redo-icons/commentsold-logo.svg";
import { CustomerTagWithId } from "@redotech/redo-model/customer";
import { CustomerTagProvider } from "@redotech/redo-model/customer-tags/customer-tag-record";
import { RedoBadgeProps } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import ShopifyIcon from "@redotech/redo-web/shopify/bag-logo.svg";
import { assertNever } from "@redotech/util/type";
import { JSXElementConstructor } from "react";

export function getIconForCustomerTagProvider(
  provider?: CustomerTagProvider | null,
): JSXElementConstructor<any> | null {
  switch (provider) {
    case CustomerTagProvider.REDO:
      return null;
    case CustomerTagProvider.COMMENTSOLD:
      return CommentsoldIcon;
    case CustomerTagProvider.SHOPIFY:
    case null:
    case undefined:
      return ShopifyIcon;
    default:
      assertNever(provider);
  }
}

export function getBadgePropsForCustomerTag(
  customerTag: Pick<CustomerTagWithId, "name" | "provider">,
): Omit<RedoBadgeProps, "size"> {
  const Icon = getIconForCustomerTagProvider(customerTag.provider);
  return {
    text: customerTag.name,
    iconTrailing: Icon ? { type: "icon", Icon, size: "sm" } : undefined,
  };
}
